<div class="row principalDarkerBackground centrado fullHeight">
  <div class="card width90 centrado">
    <div class="card-container">
      <div class="row">
        <div class="col-md-12">
          <h3 class="colorPrincipal">CAPTURA ROSTRO</h3>
        </div>
        <div class="col-md-12">
          <p class="colorSecundario fontItalic">Evite un ambiente carente de luz, procure evitar sombras y reflejos
            excesivos en el documento, <br>evite cualquier objeto en el fondo de la captura para lograr contraste</p>
        </div>
        <div class="col-md-12">
          <h3 class="colorPrincipal">CAPTURA ZOOM &reg;</h3>
        </div>

        <div class="col-md-12 centrado padding10" *ngIf="deviceChecked.isMobile">
          <img
                  src="../../../assets/images/zoom.png" />
        </div>
        <div class="col-md-12 centrado padding10" *ngIf="deviceChecked.isDesktop">
          <img
                  src="../../../assets/images/desktopMockupZoom.png" />
        </div>

        <div class="col-md-12 centrado padding10"  >
          <div class="col-md-3"></div>
          <div class="col-md-4 col-sm-6">
            <a class="nav-link botonID principalBackground padding10" routerLink="/selfie">
              OK  </a>
          </div>
          <div class="col-md-3"></div>
        </div>

      </div>

    </div>

  </div>
</div>
